import { serviceSidebarTheme, cssColor, mixWhite } from './serviceSidebarTheme'

export function isServiceRoute(route) {
  return !!route && Array.isArray(route.matched) && route.matched.some(record => record.meta && record.meta.section === 'service')
}

// 官网已保存的 GLOBAL_COLOR 是唯一来源；服务平台不维护另一份配色配置。
export function serviceTheme(style) {
  const sidebar = serviceSidebarTheme(style)
  const { brand, action, hover, pressed, ink, disabled } = sidebar.palette
  return {
    configured: sidebar.configured,
    variables: {
      ...sidebar.variables,
      '--service-brand': cssColor(brand),
      '--service-primary': cssColor(action),
      '--service-primary-hover': cssColor(hover),
      '--service-primary-pressed': cssColor(pressed),
      '--service-on-primary': '#fff',
      '--service-on-primary-hover': '#fff',
      '--service-on-primary-pressed': '#fff',
      '--service-primary-text': cssColor(ink),
      '--service-primary-disabled': cssColor(disabled),
      '--service-primary-disabled-border': '#e4e7eb',
      '--service-on-primary-disabled': '#909399',
      '--service-surface': cssColor(mixWhite(brand, 0.035)),
      '--service-surface-hover': cssColor(mixWhite(brand, 0.065)),
      '--service-surface-selected': cssColor(mixWhite(brand, 0.09)),
      '--service-table-header': cssColor(mixWhite(brand, 0.13)),
      '--service-theme-border': cssColor(mixWhite(brand, 0.3)),
      '--service-page-background': cssColor(mixWhite(brand, 0.035)),
      '--service-text': '#303133',
      '--service-muted': '#606266'
    }
  }
}
